export default "//cdn.scentbird.com/assets/frontbird-site/images/mobile-500_6220d0.jpg";